import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireSignIn } from '../auth/gate';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { DevicePage } from '../screens/device/DevicePage';

const searchSchema = z.object({
  /** The code a device's link carries (`XXXX-XXXX`); compared with Paige Scan's, never filled in. */
  code: z
    .string()
    .regex(/^[0-9A-Za-z -]{1,16}$/)
    .optional()
    .catch(undefined),
});

/**
 * Allow this device (docs/engineering/folder-monitor.md, sections 3 and 7): signed in as everywhere
 * else, on the sign-in pages' ground, outside any one company because the person picks it here.
 */
export const Route = createFileRoute('/device')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location }) => {
    await requireSignIn(context.auth, location.href);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { code } = Route.useSearch();
  return (
    <HushedFrame>
      <DevicePage linkCode={code} />
    </HushedFrame>
  );
}
